import a1 from '../../assets/img/awards/1.png';
import a2 from '../../assets/img/awards/2.png';
import a3 from '../../assets/img/awards/3.png';
import a4 from '../../assets/img/awards/4.png';
import a5 from '../../assets/img/awards/5.png';
import a6 from '../../assets/img/awards/6.png';

const AwardsSection = () => {
  return (
    <section className="awards-section">
      <h2 className="awards-title">
        <span className="text-primary">Our Awards and</span>{" "}
        Recognition
      </h2>
      <p className="awards-subtitle">
        We've supported many startups and businesses with high-quality BIM Modeling and CAD services. This dedication has earned us several awards and industry recognition.
      </p>

      <div className="awards-container">
        <div className="awards-grid">
          <div className="award-tag">
            <img src={a1.src || a1} alt="Award 1" className="award-logo" />
          </div>
          <div className="award-tag">
            <img src={a2.src || a2} alt="Award 2" className="award-logo" />
          </div>
          <div className="award-tag">
            <img src={a3.src || a3} alt="Award 3" className="award-logo" />
          </div>
          <div className="award-tag">
            <img src={a4.src || a4} alt="Award 4" className="award-logo" />
          </div>
          <div className="award-tag">
            <img src={a5.src || a5} alt="Award 5" className="award-logo" />
          </div>
          <div className="award-tag">
            <img src={a6.src || a6} alt="Award 6" className="award-logo" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;
